<script>
  import { nFormatter } from "./Utils.svelte";

  export let max_values = [1000, 1000, 1000, 1000];
  export let values = [10, 20, 40, 700];

  export let color_list;

  export let text_unten;

  let heigth = 200;

  function oben(value) {
    return heigth - unten(value);
  }

  function unten(value, index) {
    var heigth_faktor = 1;

    if (index == 3) {
      heigth_faktor = heigth / max_values[index];
    } else {
      heigth_faktor = heigth / max_values[0];
    }

    return value * heigth_faktor * 0.8;
  }
</script>

<div style="position: relative; width:100%; height:{heigth}px; display:flex; justify-content: center;">
  <table class="equalDivide small-text">
    <tr style="text-align: center; height:{heigth}px; border-bottom: 0.5pt solid #d9d9d9;">
      <td style="padding:0px; width:10px; height:{heigth}px; vertical-align:bottom;">
        <table>
          <tr style="">&nbsp;</tr>
        </table>
      </td>

      <td style="padding:0px; height:{heigth}px; vertical-align:bottom;">
        <table style="height:{heigth}px;">
          <tr style="background-color: #FFFFFF; height: {oben(values[0])}px;"
            ><td style="vertical-align:bottom;">{nFormatter(values[0])}</td></tr
          >
          <tr style="background-color: {color_list[0]}; height:{unten(values[0], 0)}px;"><td /></tr>
        </table>
      </td>
      <td style="padding:0px; height:{heigth}px; vertical-align:bottom;">
        <table style="height:{heigth}px;">
          <tr style="background-color: #FFFFFF; text-align: bottom; height: {oben(values[1])}px;"
            ><td style="vertical-align:bottom;">{nFormatter(values[1])}</td></tr
          >
          <tr style="background-color: {color_list[1]}; height:{unten(values[1], 1)}px;"><td /></tr>
        </table>
      </td>
      <td style="padding:0px; height:{heigth}px; vertical-align:bottom;">
        <table style="height:{heigth}px;">
          <tr style="background-color: #FFFFFF; text-align: bottom; height: {oben(values[2])}px;"
            ><td style="vertical-align:bottom;">{nFormatter(values[2])}</td></tr
          >
          <tr style="background-color: {color_list[2]}; height:{unten(values[2], 2)}px;"><td /></tr>
        </table>
      </td>
      <td style="padding:0px; padding-left:6px; height:{heigth}px; vertical-align:bottom;">
        <table style="height:{heigth}px;">
          <tr style="background-color: #FFFFFF; text-align: bottom; height: {oben(values[3])}px;"
            ><td style="vertical-align:bottom;">{nFormatter(values[3])}</td></tr
          >
          <tr style="background-color: {color_list[3]}; height:{unten(values[3], 3)}px;"><td /></tr>
        </table>
      </td>

      <td style="padding:0px; width:10px; height:{heigth}px; vertical-align:bottom;">
        <table>
          <tr style="">&nbsp;</tr>
        </table>
      </td>
    </tr>
    <tr class="vertical-center2">
      <td style="font-size:12px;">{text_unten}</td>
    </tr>
  </table>
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .vertical-center2 {
    margin: 0;
    margin-top: 20px;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .equalDivide tr td table tr {
    width: 17%;
  }
  /*.equalDivide tr td table tr { width:15px; }*/

  .small-text tr td table tr td {
    font-size: 12px;
  }
</style>
